import { api } from './api';
import type { Page, PageWithSections, UpdatePageInput, UpdateSectionInput } from '../types/entities';

export const pagesService = {
  /**
   * Get all pages
   */
  async getAll(): Promise<Page[]> {
    const response = await api.get<Page[]>('/api/admin/pages');
    return response.data;
  },

  /**
   * Get page by ID with sections
   */
  async getById(id: string): Promise<PageWithSections> {
    const response = await api.get<PageWithSections>(`/api/admin/pages/${id}`);
    return response.data;
  },

  /**
   * Update page
   */
  async updatePage(id: string, data: UpdatePageInput): Promise<Page> {
    const response = await api.put<Page>(`/api/admin/pages/${id}`, data);
    return response.data;
  },

  /**
   * Update section
   */
  async updateSection(id: string, data: UpdateSectionInput): Promise<void> {
    await api.put(`/api/admin/pages/sections/${id}`, data);
  },
};
